import * as React from 'react';
import classnames from 'classnames';
import Flex, { Props as FlexProps } from '../Flex/Flex';
import PlacementArrow from '../Placement/PlacementArrow';

export interface Props extends FlexProps {
  /**
   * When used as a container for multiple PlacementAreas
   * the direction can be set to split with a dividing line
   * either horizontally or vertically.
   */
  direction?: 'horizontal' | 'vertical';
  /**
   * Inserts the dynamically positioned arrow/tip.
   */
  withArrow?: boolean;
}

/**
 * The content area(s) of the placed element. This acts as the main
 * container for the content as well as the optional arrow that is dynamically
 * positioned. This component can also act as a parent to other PlacementAreas
 * when the content should be divided (see direction prop).
 */
const PlacementArea: React.FunctionComponent<Props> = (props: Props) => {
  const {
    children,
    direction,
    padding,
    paddingHorizontal,
    paddingVertical,
    withArrow,
    ...rest
  } = props;

  const classes = classnames('Placement__area', {
    [`Placement__area--${direction}`]: direction,
  });

  return (
    <Flex { ...rest } className={ classes }>
      { withArrow && <PlacementArrow /> }

      <Flex
          className="Placement__area-content"
          direction={ direction }
          padding={ padding }
          paddingHorizontal={ paddingHorizontal }
          paddingVertical={ paddingVertical }>
        { children }
      </Flex>
    </Flex>
  );
};

export default PlacementArea;
